import { Chat as ChatComponent, ChatWidget as ChatWidgetComponent } from "./app/ui";
import { withStoreProvider } from "./app/lib";
export var ChatWidget = withStoreProvider(ChatWidgetComponent);
export var Chat = withStoreProvider(ChatComponent);
export default withStoreProvider(ChatWidgetComponent);
export { AuthScheme } from "./shared/config";
export { setChatWidgetMenuOpen, setChatWidgetOpen, useChangeZIndex } from "./shared/lib";
export { ChatWidgetProvider, useChatWidget } from "./shared/model";
export { MessengersMenuFlags } from "./shared/types";